import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-services-details-page',
    templateUrl: './services-details-page.component.html',
    styleUrls: ['./services-details-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ServicesDetailsPageComponent implements OnInit {

    constructor(private route: ActivatedRoute) { }

    ngOnInit(): void {
        // const id = Number(this.route.snapshot.paramMap.get('id'));
        // this.populateDetails(id);

        this.route.paramMap.subscribe(params => {
            const id = Number(params.get('id'));
            this.populateDetails(id);
        });
    }

    populateDetails(id: number) {
        this.servicesDetailsDesc = this.servicesDetailsDescAll.filter(x => x.id === id);
        this.servicesDetailsImage = this.servicesDetailsImageAll.filter(x => x.id === id);
        this.pageTitleArea = this.pageTitleAreaAll.filter(x => x.id === id);
        this.servicesDetailsDescTechnologiesFeatures = this.servicesDetailsDescTechnologiesFeaturesAll.filter(x => x.id.includes(id));
    }

    pageTitleArea: pageTitle[] = [

    ]
    pageTitleAreaAll: pageTitle[] = [
        {
            id: 1,
            title: 'Service Details',
            subTitle: 'Web Development',
        },
        {
            id: 2,
            title: 'Service Details',
            subTitle: 'Dedicated Development Team',
        },
        {
            id: 3,
            title: 'Service Details',
            subTitle: 'AI & App Development',
        }
    ]
    servicesDetailsImage: DetailsImage[] = [

    ]
    servicesDetailsImageAll: DetailsImage[] = [
        {
            id: 1,
            img: 'assets/img/services/webdev.jpg'
        },
        {
            id: 2,
            img: 'assets/img/services/dedicateddevteam.jpeg'
        },
        {
            id: 3,
            img: 'assets/img/services/aidev.png'
        }
    ]
    servicesDetailsDesc: DetailsDesc[] = [

    ]
    servicesDetailsDescAll: DetailsDesc[] = [
        {
            id: 1,
            subTitle: 'Web Development',
            title1: 'About',
            paragraphText1: 'At Devotory, we provide end-to-end web development services across all major frameworks and technologies, ensuring a tailored approach to meet your unique needs.',
            paragraphText2: '<b>Backend Development:</b> Build powerful, scalable server-side solutions using technologies like .NET and Python, designed to handle complex business logic and integrate seamlessly with various systems. <br><br><b>Frontend Development:</b> Create engaging, user-friendly interfaces with modern frameworks including Angular, React, and Next.js. Our focus is on delivering intuitive and responsive designs that enhance user experience. <br><br><b>Custom Solutions:</b> Whether you need a robust e-commerce platform, a dynamic content management system, or a custom-built web application, we tailor our services to meet your specific requirements.',
            title2: 'Important Facts',
            title3: 'Application Areas',
            title4: 'Technologies That We Use',
            img1: 'assets/img/projects/img2.jpg',
            img2: 'assets/img/services/charts.jpg'
        },
        {
            id: 2,
            subTitle: 'Dedicated Development Team',
            title1: 'About',
            paragraphText1: 'We provide dedicated development teams at competitive hourly rates, giving you access to top-tier talent without the overhead of traditional hiring. Our developers are highly skilled and bring a wealth of experience to your projects. Here’s what we offer:',
            paragraphText2: '<b>Top Talent:</b> Our developers are carefully selected for their expertise and ability to deliver high-quality results. <br><br><b>Affordable Rates:</b> Enjoy exceptional skills at a cost-effective price point. Flexible Engagement: Start with a one-month free trial to assess our developers performance and fit for your project. <br><br><b>Seamless Integration:</b> Our teams work as an extension of your in-house staff, ensuring smooth collaboration and project alignment.',
            title2: 'Important Facts',
            title3: 'Application Areas',
            title4: 'Technologies That We Use',
            img1: 'assets/img/projects/img2.jpg',
            img2: 'assets/img/services/charts.jpg'
        },
        {
            id: 3,
            subTitle: 'AI & App Development',
            title1: 'About',
            paragraphText1: 'At Devotory, we excel in developing cutting-edge AI applications that drive innovation and deliver impactful results. Our expertise spans a range of AI technologies and methodologies, tailored to meet your specific needs:',
            paragraphText2: '<b>Machine Learning (ML):</b> Build intelligent systems that learn and adapt from data to provide predictive insights and automate processes. <br><br><b>Artificial Intelligence (AI):</b> Develop advanced AI solutions to enhance decision-making, improve efficiency, and create smarter applications. <br><br><b>Large Language Models (LLM):</b> Implement sophisticated language models for natural language understanding and generation, enabling advanced conversational interfaces and more.',
            title2: 'Important Facts',
            title3: 'Application Areas',
            title4: 'Technologies That We Use',
            img1: 'assets/img/projects/img2.jpg',
            img2: 'assets/img/services/charts.jpg'
        }
    ]
    servicesDetailsDescImportantFacts: ImportantFacts[] = [
        {
            title: 'The Field of Data Science'
        },
        {
            title: 'The Problem'
        },
        {
            title: 'The Solution'
        },
        {
            title: 'The Skills'
        },
        {
            title: 'Statistics'
        },
        {
            title: 'Mathematics'
        }
    ]
    servicesDetailsDescApplication: Application[] = [
        {
            title: 'Manufacturing',
            icon: 'flaticon-factory'
        },
        {
            title: 'Healthcare',
            icon: 'flaticon-hospital'
        },
        {
            title: 'Automobile',
            icon: 'flaticon-tracking'
        },
        {
            title: 'Banking',
            icon: 'flaticon-investment'
        },
        {
            title: 'Real Estate',
            icon: 'flaticon-house'
        },
        {
            title: 'Logistics',
            icon: 'flaticon-order'
        }
    ]
    servicesDetailsDescTechnologiesFeatures: TechnologiesFeatures[] = [

    ]
    servicesDetailsDescTechnologiesFeaturesAll: TechnologiesFeatures[] = [
        {
            id: [1,2,3],
            title: 'JavaScript'
        },
        {
            id: [1,2,3],
            title: 'Angular'
        },
        {
            id: [1,2,3],
            title: 'React.js'
        },
        {
            id: [1,2,3],
            title: 'HTML5 / CSS3 / SASS'
        },
        {
            id: [1,2,3],
            title: 'TypeScript'
        },
        {
            id: [1,2,3],
            title: 'JavaScript (ES6+)'
        },
        {
            id: [1,2,3],
            title: 'ASP.NET Core'
        },
        {
            id: [1,2,3],
            title: 'Node.js / Express'
        },
        {
            id: [1,2,3],
            title: 'RESTful API Development'
        },
        {
            id: [1,2,3],
            title: 'PostgreSQL'
        },
        {
            id: [1,2,3],
            title: 'SQL Server'
        },
        {
            id: [1,2,3],
            title: 'Redis'
        },
        {
            id: [1,2,3],
            title: 'AWS'
        },
        {
            id: [1,2,3],
            title: 'Azure'
        },
        {
            id: [1,2,3],
            title: 'Docker / Containerization'
        },
        {
            id: [1,2,3],
            title: 'CI/CD Pipelines (GitHub Actions, Azure DevOps)'
        }
    ]

    sidebarServicesList: ServicesList[] = [
        {
            title: 'Service Detail',
            link: 'services-details'
        },
        {
            title: 'Resturents',
            link: 'services-details'
        },
        {
            title: 'Flower Shops',
            link: 'services-details'
        },
        {
            title: 'Mobile Reparing',
            link: 'services-details'
        },
        {
            title: 'Coffe Shop',
            link: 'services-details'
        }
    ]
    sidebarDownloadFile: DownloadFile[] = [
        {
            title: 'PDF Download',
            icon: 'bx bxs-file-pdf',
            link: 'assets/img/services/DevotoryProfile.pptx'
        },
        // {
        //     title: 'Services Details.txt',
        //     icon: 'bx bxs-file-txt',
        //     link: 'services-details'
        // }
    ]
    sidebarContactInfo: ContactInfo[] = [
        {
            icon: 'bx bx-user-pin',
            title: 'Phone',
            subTitle: '+1 (209) 500 1603'
        },
        {
            icon: 'bx bx-map',
            title: 'Location',
            subTitle: '30 N Gould Street, Sheridan, Wyoming 82801'
        },
        {
            icon: 'bx bx-envelope',
            title: 'Email',
            subTitle: 'info@devotory.com'
        }
    ]

}
class pageTitle {
    id: number;
    title: string;
    subTitle: string;
}
class DetailsImage {
    id: number;
    img: string;
}
class DetailsDesc {
    id: number;
    subTitle: string;
    title1: string;
    title2: string;
    title3: string;
    title4: string;
    paragraphText1: string;
    paragraphText2: string;
    img1: string;
    img2: string;
}
class ImportantFacts {
    title: string;
}
class Application {
    title: string;
    icon: string;
}
class TechnologiesFeatures {
    id: number[];
    title: string;
}

class ServicesList {
    title: string;
    link: string;
}
class DownloadFile {
    title: string;
    icon: string;
    link: string;
}
class ContactInfo {
    icon: string;
    title: string;
    subTitle: string;
}